module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy"
  }, [_c('div', {
    staticClass: "service"
  }, [(_vm.showPoster) ? _c('a', {
    staticClass: "dial",
    attrs: {
      "href": _vm.posterURL
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/poster.png"
    }
  }), _c('span', [_vm._v("海报")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "dial",
    attrs: {
      "id": "tel-ask-about",
      "href": _vm.tel
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/phone.png"
    }
  }), _c('span', [_vm._v("客服")])])]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('p', [_vm._v("价格: "), (_vm.measureReady === false) ? _c('span', [_c('i', {
    staticClass: "number"
  }, [_vm._v("暂无")])]) : _c('span', [_vm._v("￥"), _c('i', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v(".00/年"), (_vm.measureReady === '') ? _c('i', [_vm._v(" 起")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function () {
        this$1.$emit('clickBuy')
      }
    }
  }, [_c('span', [_vm._v("立即购买")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5aa1e1e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Buy.vue
// module id = 667
// module chunks = 1